import React from 'react';
import { Package, AlertTriangle, ChevronRight, BookOpen } from 'lucide-react';
import { format, parseISO, isAfter } from 'date-fns';

const PRIORITY_COLORS = { critical:'#EF4444', high:'#F97316', medium:'#F59E0B', low:'#10B981' };
const STATUS_BG = { pending:'#FEF3C7', assigned:'#EDE9FE', in_progress:'#E0F2FE', completed:'#D1FAE5' };
const STATUS_TEXT = { pending:'#92400E', assigned:'#5B21B6', in_progress:'#0C4A6E', completed:'#065F46' };

export default function MobileJobCard({ job, onClick }) {
  const isOverdue = job.due_date && isAfter(new Date(), new Date(job.due_date)) && !['completed','cancelled'].includes(job.status);
  
  return (
    <div onClick={onClick} style={{
      background:'var(--bg-card)', 
      border:`1.5px solid ${isOverdue ? '#EF4444' : 'var(--border)'}`,
      borderRadius:'var(--r-lg)', 
      padding:'16px', 
      cursor:'pointer',
      transition:'all 150ms', 
      boxShadow: isOverdue ? '0 0 0 3px rgba(239,68,68,0.1)' : 'var(--shadow-sm)',
      position: 'relative',
      overflow: 'hidden'
    }} className="hover-lift">
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:8 }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <div style={{ fontFamily:'var(--font-mono)', fontSize:10, color:'var(--accent)', fontWeight:700, opacity: 0.8 }}>{job.job_number}</div>
            {job.reference_documents?.length > 0 && (
              <div style={{ display:'flex', alignItems:'center', gap:3, color:'#0284C7', background:'#E0F2FE', padding:'1px 6px', borderRadius:4, fontSize:9, fontWeight:800, textTransform:'uppercase' }}>
                <BookOpen size={10} fill="rgba(2,132,199,0.1)" />
                Ref
              </div>
            )}
          </div>
          <div style={{ fontSize:15, fontWeight:800, color:'var(--text)', marginTop:2, lineHeight:1.2 }}>{job.title}</div>
        </div>
        <div style={{
          padding:'3px 10px', borderRadius:'var(--r-full)', fontSize:10, fontWeight:700,
          background: STATUS_BG[job.status] || 'var(--bg-muted)',
          color: STATUS_TEXT[job.status] || 'var(--text-muted)',
          textTransform: 'uppercase'
        }}>
          {job.status?.replace('_',' ')}
        </div>
      </div>

      {job.asset_name && (
        <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:10 }}>
          <Package size={12} color="var(--text-muted)" />
          <span style={{ fontSize:12, color:'var(--text-secondary)', fontWeight: 500 }}>{job.asset_name}</span>
          {job.asset_location && <span style={{ fontSize:12, color:'var(--text-muted)' }}>· {job.asset_location}</span>}
        </div>
      )}

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop: 4 }}>
        <div style={{ display:'flex', alignItems:'center', gap:5 }}>
          <div style={{ width:7, height:7, borderRadius:'50%', background:PRIORITY_COLORS[job.priority] }} />
          <span style={{ fontSize:11, fontWeight:700, color:PRIORITY_COLORS[job.priority], textTransform: 'uppercase' }}>{job.priority}</span>
        </div>
        
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          {job.due_date && (
            <div style={{ display:'flex', alignItems:'center', gap:4 }}>
              {isOverdue && <AlertTriangle size={12} color="#EF4444" />}
              <span style={{ fontSize:12, fontWeight:600, color: isOverdue ? '#EF4444' : 'var(--text-muted)' }}>
                {format(parseISO(job.due_date), 'MMM d, HH:mm')}
              </span>
            </div>
          )}
          <ChevronRight size={16} color="var(--text-muted)" opacity={0.5} />
        </div>
      </div>
    </div>
  );
}
